import Cookies from "js-cookie";

window.Cookies = Cookies;

export default Cookies;
